import {
  Button,
  JoonUIColor,
  ModalHeader,
  Typography,
} from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import SlideUpModal from "../../components/slideUpModal/SlideUpModal"
import { useEndScreenTimeSessionMutation } from "../../networking/rewards/mutations"
import { ScreenTimeLog } from "../../types/rewards"

type Props = {
  isOpen: boolean
  onClose: () => void
  session: ScreenTimeLog | null
}

const EndScreenTimeUseModal = ({ isOpen, onClose, session }: Props) => {
  const endSessionMutation = useEndScreenTimeSessionMutation()
  const { t } = useTranslation()

  const handleEndSession = () => {
    if (session) {
      endSessionMutation.mutate(
        { sessionId: session.id },
        { onSuccess: onClose }
      )
    }
  }

  return (
    <SlideUpModal
      isOpen={isOpen}
      onClose={onClose}
      size="fit-content"
      backgroundType="overlay"
      showCard={true}
    >
      <ModalHeader title={t("REWARD_END_ST_TITLE")} onClose={onClose} />
      <div className="flex flex-col gap-4 max-w-[450px] w-full p-6 pt-0">
        <Typography variant="body" color={JoonUIColor.text.secondary}>
          {t("REWARD_END_ST_DESC")}
        </Typography>
        <Button
          onClick={handleEndSession}
          text={t("REWARD_END_ST_BTN")}
          fullWidth
          disabled={endSessionMutation.isLoading}
          buttonType="primary"
        />
      </div>
    </SlideUpModal>
  )
}

export default EndScreenTimeUseModal
